/**
 * Schedule module (BUILD-PLAN M03). Owner of the page, toolbar, panels and
 * this manifest: WP1-SCHED-PANELS; the grid (`./grid/**`) is WP1-SCHED-GRID's
 * and plugs in through `./seam.ts`. Replaces the shell's Schedule placeholder
 * (same id and path).
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'schedule',
    title: 'Schedule',
    version: '0.1.0',
    owner: 'WP1-SCHED-PANELS',
    entitlementKey: null,
    permissions: ['schedule.view', 'schedule.edit', 'money.view', 'task.create', 'settings.manage'],
    routes: [
      {
        id: 'day',
        path: '/schedule',
        title: 'Schedule',
        officeScope: 'location',
        permission: 'schedule.view',
        readsPhi: true,
      },
      {
        id: 'offices',
        path: '/schedule/offices',
        title: 'All offices',
        officeScope: 'location-or-all',
        permission: 'schedule.view',
        readsPhi: true,
      },
      {
        id: 'calls',
        path: '/schedule/calls',
        title: 'Call list',
        officeScope: 'location',
        permission: 'schedule.view',
        readsPhi: true,
      },
      {
        id: 'productivity',
        path: '/schedule/productivity',
        title: 'Schedule productivity',
        officeScope: 'location',
        permission: 'schedule.view',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Schedule',
        labelKey: 'schedule',
        group: 'schedule',
        routeId: 'day',
        icon: 'calendar-days',
        order: 10,
        permission: 'schedule.view',
      },
      {
        label: 'All offices',
        group: 'schedule',
        routeId: 'offices',
        icon: 'building-2',
        order: 11,
        permission: 'schedule.view',
      },
      {
        label: 'Call list',
        group: 'schedule',
        routeId: 'calls',
        icon: 'phone',
        order: 13,
        permission: 'schedule.view',
      },
      {
        label: 'Productivity',
        group: 'schedule',
        routeId: 'productivity',
        icon: 'trending-up',
        order: 12,
        permission: 'schedule.view',
      },
    ],
    commands: [
      {
        id: 'schedule.open',
        title: 'Go to Schedule',
        keywords: ['calendar', 'appointments', 'day', 'book', 'pinboard'],
        routeId: 'day',
        permission: 'schedule.view',
      },
      {
        id: 'schedule.offices',
        title: 'All offices schedule board',
        keywords: [
          'holes',
          'openings',
          'unconfirmed',
          'asap',
          'fill rate',
          'group',
          'offices',
          'other views',
        ],
        routeId: 'offices',
        permission: 'schedule.view',
      },
      {
        id: 'schedule.calls',
        title: 'Call list (ASAP, broken, unscheduled, recall, unconfirmed)',
        keywords: [
          'call',
          'phone',
          'asap',
          'broken',
          'unscheduled',
          'recall',
          'unconfirmed',
          'other views',
        ],
        routeId: 'calls',
        permission: 'schedule.view',
      },
      {
        id: 'schedule.productivity',
        title: 'Schedule productivity',
        keywords: [
          'scheduled production',
          'open time',
          'goal pace',
          'reappointment',
          'no-show',
          'risk',
          'pace',
          'production per hour',
          'perfect day',
          'other views',
        ],
        routeId: 'productivity',
        permission: 'schedule.view',
      },
    ],
    shortcuts: [{ keys: 'g s', description: 'Go to Schedule', routeId: 'day' }],
    sseEntityKeys: [],
    phiReadPoints: [
      'schedule.range',
      'schedule.appointment_detail',
      'schedule.lists',
      'schedule.reappointment',
      'appointment.next_visit',
      'schedule.no_show_risk',
    ],
  }),
  pages: {
    day: () => import('./SchedulePage.js'),
    offices: () => import('./offices/AllOfficesPage.js'),
    calls: () => import('./calls/CallListPage.js'),
    productivity: () => import('./productivity/ProductivityPage.js'),
  },
});
